import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';


const Footer = () => {
  return (
    <>

      <footer className="footer-section-1 footer-bg fix">
        <div className="container">
          <div className="footer-widget-wrapper">
            <div className="row">
              <div className="col-xl-5 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".2s">
                <div className="single-footer-widget">
                  <div className="widget-head">
                    <Link to="/" className="footer-logo">
                      <img src="assets/img/svp/logo_1.jpeg" alt="logo-img" style={{ width: "220px", height: "174px", borderRadius:"5px" }} />
                    </Link>
                  </div>
                  <div className="footer-content">
                    <p>
                      Saraswati Vidyapeeth HR. SEC. School is one of the best health and safety course providers in India. is approved by the government of India.
                    </p>

                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp" data-wow-delay=".4s">
                <div className="single-footer-widget">
                  <div className="widget-head">
                    <h3>Quick Link</h3>
                  </div>
                  <ul className="list-items">
                    <li>
                      <Link to="/">
                        Home
                      </Link>
                    </li>

                    <li>
                      <Link to="/gallery">
                        Gallery
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/blog">
                        Blog
                      </Link>
                    </li> */}
                    <li>
                      <Link to="/about">
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact">
                        Contact Us
                      </Link>
                    </li>

                  </ul>
                </div>
              </div>
              {/* <div className="col-xl-2 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp" data-wow-delay=".6s">
                <div className="single-footer-widget">
                  <div className="widget-head">
                    <h3>Resources</h3>
                  </div>
                  <ul className="list-items">
                    <li>
                      <a to="courses-details.html">
                        All Courses
                      </a>
                    </li>
                    <li>
                      <a to="contact.html">
                        Digital Marketing
                      </a>
                    </li>
                    <li>
                      <a to="contact.html">
                        Design &amp; Branding
                      </a>
                    </li>
                    <li>
                      <a to="contact.html">
                        Storytelling &amp; Voice Over
                      </a>
                    </li>
                    <li>
                      <a to="news.html">
                        News &amp; Blogs
                      </a>
                    </li>
                  </ul>
                </div>
              </div> */}
              <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".8s">
                <div className="single-footer-widget">
                  <div className="widget-head">
                    <h3>Our Newsletter</h3>
                  </div>
                  <div className="footer-content">
                    {/* <p>Recent News</p> */}
                    {/* <div className="footer-input">
                      <input type="email" id="email2" placeholder="Enter Your Email" />
                      <button className="theme-btn" type="submit">
                        Subscribe
                      </button>
                    </div> */}
                    <a to="index.html" className="footer-logo">
                      <img src="assets/img/svp/200w.gif" style={{ width: "70px", height: "70px" }} alt="logo-img" />
                      <img src="assets/img/svp/giphy.gif" style={{ width: "70px", height: "70px" }} alt="logo-img" />
                      <img src="assets/img/svp/make.gif" style={{ width: "70px", height: "70px", borderRadius:"50px" }} alt="logo-img" />
                      {/* <br />
                      <img src="assets/img/svp/logo_1.jpeg" style={{width:"100px", height:"100px"}} alt="logo-img" />
                      <img src="assets/img/svp/logo_2.jpeg" style={{width:"70px", height:"70px"}} alt="logo-img" /> */}
                      {/* <img src="assets/img/logo/white-logo.svg" alt="logo-img" /> */}
                    </a>

                    <ul className="contact-list">
                      <li>
                        <i className="fa-regular fa-location-dot" />
                        <a href='https://share.google/UtLy4KFdIpQWtw3Xz' target="_blank" >Saraswati Vidyapeeth School Utaili, Satna</a>
                      </li>
                      <li>
                        <i className="fa-sharp fa-solid fa-phone" />
                        <a href="tel:+91 7000664954">+91 7000664954</a><br />
                        <i className="fa-sharp fa-solid fa-phone" />
                        <a href="tel:+91 7000664954">+91 6265386826</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom" style={{ marginTop: "-50px" }}>
            <div className="footer-wrapper" style={{ marginTop: "-30px" }}>
              <p className="wow fadeInUp" data-wow-delay=".3s">
                2026 © Saraswati Vidyapeeth HR. SEC. School | Designed by <a href="tel:+91 8982471422" style={{ color: "white" }} target="_blank"> Web solution & digital marketing</a>
              </p>
              <div className="bottom-list wow fadeInUp" data-wow-delay=".5s" >
                <div className="social-icon d-flex align-items-center">
                  <a href="https://www.facebook.com/share/19cCH8TPEA/" target="_blank"><i className="fab fa-facebook-f" /></a>
                  <a href="https://www.instagram.com/saraswatiawasiyavidyapeeth?utm_source=ig_web_button_share_sheet&igsh=amh6a2twc3phNXl3" target="_blank" className="bg-2"><i className="fab fa-instagram" /></a>
                  <a href="https://www.youtube.com/@saraswatiawasiyavidyapeeth" target="_blank"><i className="fab fa-youtube" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>



      <WhatsappIcon />

    </>
  )
}

export default Footer